<template>
 
    <!-- 编辑表单 -->
    <div   >
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
        </div> 
        <div style=" overflow-y:auto;height:88vh;">
            <el-tabs :animated="false"   v-model="active">
                <el-tab-pane name="first">
                    <span slot="label"><i class="iconfont icon-shujuzidian"></i> 产品资料</span> 
                    <div v-for="(gpitem,gpind) in formArr" :key="gpind" >
                        <div class="one-toolbar">
                            <span class="spanRow"> {{gpitem.gpnm}} </span>
                        </div>

                        <Form :model="matRow" :label-width="120" ref="supForm"  label-position="right" inline  >  
                            <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                <FormItem   :label="item.FLDNM"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                    <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="matRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-checkbox border size="small" v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="matRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                    <el-select size="small" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" @change="prcChg(item.key)" v-model="matRow[item.FLDNO]" clearable   style="width:100%">
                                        <el-option v-for="(it,ind) in comboArr[item.FLDNO]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                                    </el-select>
                                    <el-input-number  size="small" :precision="item.DOTNUM" v-else-if="item.EDCSS=='number'" @change="prcChg(item.key)" style="width:100%" :disabled="saveFlag" v-model="matRow[item.FLDNO]" controls-position="right"></el-input-number>
                                    <el-input type="number" size="small" :disabled="saveFlag" v-else-if="item.FLDNO==='OUTPRC'" v-model="matRow[item.FLDNO]" style="width:100%" >
                                        <el-select slot="append" size="small"  v-model="matRow['OUTCRCY']" placeholder="请选择货币"  style="width:140px;background:white;">
                                            <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select>
                                    </el-input>
                                    <el-input type="number" size="small" :disabled="saveFlag" v-else-if="item.FLDNO==='PRC'" v-model="matRow[item.FLDNO]" style="width:100%" >
                                        <el-select slot="append" size="small"  v-model="matRow['CRCY']" placeholder="请选择货币"  style="width:140px;background:white;">
                                            <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select>
                                    </el-input>
                                    <el-input type="text" size="small" v-else-if="item.key==='MATTYNM'" readonly  v-model="matRow[item.FLDNO]">
 
                                    </el-input>
                                    <el-input size="small" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="matRow[item.FLDNO]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
                        <!-- 产品参数:14737-->
                        <span v-if="gpitem.gpno==='14373'"> 
                            <Form :model="paramRow" :label-width="120" ref="paramWin"  label-position="right" inline >  
                                <span v-for="(item,index) in paramArr" :key="index" >
                                    <FormItem  :label="item.cname"  class="item-width"  >
                                        <span v-if="item.ishand==='Y'">
                                            <el-input size="small" :disabled="saveFlag" clearable placeholder="请输入"  @input="modelChange"   v-model="paramRow[item.lstseq]" style="width:100%"></el-input>
                                        </span>
                                            <span v-else>
                                            <el-select size="small" :disabled="saveFlag" placeholder="请选择"   @change="modelChange" v-model="paramRow[item.lstseq]"  style="width:100%" filterable clearable>
                                                <el-option v-for="(it,ind) in item.children" :key="ind" :value="it.code" :label="it.cname" ></el-option>
                                            </el-select> 
                                        </span>
                                    </FormItem>
                                </span>
                            </Form>
                        </span>
                        <!-- 产品图片:14374 -->
                        <span v-if="gpitem.gpno==='14374'"> 
                            <div style="display:flex" >
 
                                <div style="display:flex;margin-left:30px;"  >
                                    <span v-for="(item,index) in imgData" :key="index">  
                                        <el-image :preview-src-list="[item.FILEPATH]" style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image> 
 
                                    </span>
                                </div> 
                            </div>
                        </span>
                        <!-- 数据手册:14375  -->
                        <span v-if="gpitem.gpno==='14375'"> 
                            <div style="display:flex" >
 
                                <div v-if="pdfUrl.length>2" style="display:flex;flex-direction:column;height:200px;margin-left:100px;"  >
                                    <div style="height:35px;background:#e8eaec;width:300px; display:flex;justify-content:center">
                                        <el-link v-if="pdfUrl.lastIndexOf('pdf')>-1" :underline="false" style="margin-right:100px;" @click="pdfViewer"><Icon type="ios-search" />查看</el-link>
                                        <el-link v-else :underline="false" style="margin-right:100px;" @click="downFile"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
 
                                    </div> 
                                    <div v-if="pdfUrl.lastIndexOf('pdf')>-1" style="width:300px;height:165px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <iframe :src="pdfUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                    </div>
                                    <div v-else style="width:300px;height:165px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <span style="font-weight:600;font-size:12px;color:red"> 技术手册文件：</span>{{pdfUrl}}
                                    </div>
                                </div> 
                            </div>
                        </span>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label"><i class="iconfont icon-navicon-qghztj"></i> 产品销售明细</span> 
                    <el-table  :data="ordData" 
                        border            
                        class="custom-table-border"                
                        disabled-hover
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :height="tabHeight" 
                        highlight-current-row>
                    <span v-for="(item,index ) in ordArr" :key="index">
                        <el-table-column  v-if="item.thide==='N'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="third">
                    <span slot="label"><i class="iconfont icon-caigouguanli-"></i> 产品采购明细</span> 
                    <el-table  :data="poData" 
                        border       
                        class="custom-table-border"                     
                        disabled-hover
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :height="tabHeight" 
                        highlight-current-row>
                    <span v-for="(item,index ) in poArr" :key="index">
                        <el-table-column  v-if="item.thide==='N'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
            <span style="float:right" >
                <el-button v-if="v_idseq.length>1" type="text" icon="iconfont icon-shangyiye"  @click="prevRec" style="margin-right:20px;">上条记录</el-button>
                <el-button v-if="v_idseq.length>1" type="text" icon="iconfont icon-xiayiye1"  @click="nextRec" style="margin-right:20px; ">下条记录</el-button>
                <span :style="stfgColor">
                    <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:40px;height:35px;vertical-align:middle"></i>
                </span>
                <el-button type="info" @click="btnExit" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
 
            </span>
        </div>
    </div>
 
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate } from '../../api/Select' 
 
import FileSaver from 'file-saver'
//局部注册
export default {
    name:"prd_browser",
    data () {
        return {
 
            prevFlag:false,
            nextFlag:false,
            crcyArr:[],
 
 
            ishand:'',

            cname:'',
            stfg:'',
            sortby:'',
            drawer:false,
           
 
            saveFlag:true,
            promtWin:false,
            prompt:'',
            stfgCss:'',
            active:'first',
            perWin:false,
            stfgColor:'',
            ordData:[],
            poData:[],
            poArr:[],
            matRow:{},
            listurl:'',//放大的图片
 
   
   
            ordArr:[],
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
 
            formArr:[],
 
            allData:[],
            tabArr:[], //表列
            paramArr:[], //属性数组
            paramRow:{},
            imgData:[],

            comboArr:{},
 
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
 
            current:1,
            v_k :'',
 
            v_idseq:'', 
            pdfUrl:'N',
  
        }
    },
    mounted () { 
 
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','PARENTNO','4237','','','v_sys_base','').then(res=>{
            this.crcyArr =res.result
        })
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','4272','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promtWin=true
                this.prompt=res.result
            }
        })
 
    },
    computed: {
        scrollerHeight: function() {
            return (window.innerHeight - 125) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
    },
    components: {
 
    },
    created () {       
 
        //查询数据
        this.queryEvent()
        this.getTabField() //表列字段
 
    },
    watch: {
 
    },
    methods: {
        btnExit(){
            this.drawer=false
            this.$emit('child-exit')
        },
        initData(idseq){
            this.v_idseq =idseq.split(',')
            this.v_k =0
 
            this.getMatOne(this.v_idseq[0])
 
        },
        // 得到 一产品记录
        getMatOne(idseq){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idno', p_value:idseq,p_key2:'corpid', p_value2:this.v_corpid,p_cond:'',p_table:'V_BS_mat'},
            }).then(res=>{ 
                //行赋值    
                this.matRow =res.result[0]  //深拷贝
                if (this.matRow.PDFPATH){
                    this.pdfUrl =this.matRow['PDFPATH']
                }else{
                    this.pdfUrl ='N'
                }
                //产品参数   
                this.paramArr=[]
                this.getProdParam(this.matRow['MATTY']) //来自于物料属性库
                //产品参数值 
                this.paramRow={}
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'idseq',p_value:this.matRow['IDSEQ'],p_table:'mat_spec'},
                }).then(res=>{      
                    for (let k=0;k<res.result.length;k++){   
                        this.paramRow[res.result[k]['REFLSTSEQ']] =res.result[k]['CODE']       
                    }
                })
                
                //产品图片
                this.qryImgData(this.matRow['IDSEQ']) 
                //销售订单
                this.getOrdList(this.matRow['IDNO'])
                //采购订单
                this.getPoList(this.matRow['IDNO'])
                this.rowClick(this.matRow)
            })
        },
        prcChg(key){
            if (key=='POPRC'||key=='PONOPRC'||key=='TAXNUM'){
                var v_rate=''
                if (this.matRow['TAXNUM']){
                    this.comboArr['TAXNUM'].some(item=>{
                        if (item.CODE==this.matRow['TAXNUM']){
                            v_rate =item['SUBNO']
                        }
                    })
                }
                if (key=='POPRC' && this.matRow['POPRC'] && v_rate!==''){
                    this.matRow['PONOPRC'] =(Number(this.matRow['POPRC'])/(100+Number(v_rate))*100).toFixed(4)
                }else if (key=='PONOPRC' &&  this.matRow['PONOPRC'] && v_rate!==''){
                    this.matRow['POPRC'] =(Number(this.matRow['PONOPRC'])*(100+Number(v_rate))/100).toFixed(4)
                }else if (key=='TAXNUM' ){
                    if ( this.matRow['POPRC']){
                        this.matRow['PONOPRC'] =(Number(this.matRow['POPRC'])/(100+Number(v_rate))*100).toFixed(4)
                    }else{
                        this.matRow['POPRC'] =(Number(this.matRow['PONOPRC'])*(100+Number(v_rate))/100).toFixed(4)
                    }
                }
            }
        },
 
        //上行、下行记录
        prevRec(){
            this.v_k =Number(this.v_k)-1
            if (this.v_k>=0) { 
                this.getMatOne(this.v_idseq[this.v_k])
            }else{
                this.v_k =0
            }
         
        },
        nextRec(){
            let v_len  =this.v_idseq.length
            this.v_k =Number(this.v_k)+1
            if (this.v_k<=v_len-1) { 
                this.getMatOne(this.v_idseq[this.v_k])
            }else{
                this.v_k =v_len-1
            }
        },
 
        //预览PDF
        pdfViewer(){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:this.pdfUrl },
            });
            window.open(routeUrl.href, '_blank');
        },
        downFile(){
            //let blob =new Blob([this.pdfUrl],{type:'text/plain;charset=utf-8'})
            const arr_name=this.pdfUrl.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(this.pdfUrl,file_name) 
        },
 
        //重新刷新产品属性和 属性值
        getProdParam(idseq){
            //产品参数   
            let cond_=' and (idseq='+idseq+' or idseq=(select parentno from bs_type where code=\''+idseq+'\')) order by sortby,lstseq'
            this.$axios({
                method: 'post',
                url:'xuper_auth/getPrdSpec',
                data: {p_key:'corpid',p_value:this.v_corpid, p_key2:'STFG',p_value2:'Y',p_cond:cond_,p_table:'V_PRD_PROP'},
            }).then(res=>{      
                this.paramArr =res.result 
            }) 
        },
        modelChange(){
            this.$forceUpdate()
        },
  
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
   
        },
 
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'4272',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
 
        //产品订单明细
        getOrdList(matno){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'matno', p_value:matno,p_key2:'corpid', p_value2:this.v_corpid, p_table:'V_orditm'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.ordData=res.result
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }) 
        },
        //采购订单明细
        getPoList(matno){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'matno', p_value:matno,p_key2:'corpid', p_value2:this.v_corpid, p_table:'V_po_orddtl'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.poData=res.result
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }) 
        },
        getRowKey(row){
            return row.IDSEQ
        },
        queryEvent(){
            let cond_=''
 
            //(cond_)
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        sort:res.result[k].SORTABLE,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .item-width{
        height:20px !important;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
 
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
         ::-webkit-scrollbar {
    width: 4px;
  }
 
  ::-webkit-scrollbar-track {
    background-color: #f5f7f9;
  }
    
    ::-webkit-scrollbar-thumb {
    background-color: #acd6ff;
    }
    
    ::-webkit-scrollbar-thumb:hover {
    background-color: #acd6ff;
    }
    
    ::-webkit-scrollbar-thumb:active {
    background-color: #acd6ff;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
     .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 